<template>
    <ToolsInventory></ToolsInventory>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ToolsInventory = defineAsyncComponent(() =>
    import("../../components/Purchasing/ToolsInventory/ToolsInventory.vue")
);

export default {
    name: "Tools_Inventory", //The name you are in should not equal the name of the component you are importing.
    components: { ToolsInventory, AuthLayout },
};
</script>
